import { useEffect, useRef, useState } from 'react';

// Tracks whether an element is on screen so 3D canvases can pause when hidden.
export default function useInView(rootMargin = '100px') {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el || typeof IntersectionObserver === 'undefined') {
            setInView(true);
            return undefined;
        }
        const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), { rootMargin });
        observer.observe(el);
        return () => observer.disconnect();
    }, [rootMargin]);

    return [ref, inView];
}
